<!-- Header da Pagina (oculto no modo embutido: a aba do Operar Cliente ja tem titulo) -->
<div class="page-header" *ngIf="!embutido">
  <div class="header-icon">
    <i class="pi pi-box"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- TabView: Cadastro e Lista -->
<div class="tabs-container" [class.embutido]="embutido">
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">

    <!-- Aba 1: Cadastro -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-plus-circle tab-icon"></i>
        <span>{{ texts.aba_cadastro }}</span>
      </ng-template>

      <!-- Banner de edicao -->
      <div class="editing-banner" *ngIf="form.id">
        <i class="pi pi-pencil"></i>
        <span>{{ texts.titulo_editar }} - {{ form.nome }}</span>
        <!-- Compartilhar URL do Mini Shop deste item. Ativo apenas quando o item
             tem saldo > 0 E "Habilitar Mini Shop" = Sim (valor atual do form).
             Quando indisponivel, fica DESABILITADO com tooltip explicativo. -->
        <button pButton
          type="button"
          icon="pi pi-share-alt"
          class="p-button-rounded p-button-text editing-banner-share"
          [disabled]="!podeCompartilharEdicao()"
          [attr.aria-label]="tooltips.compartilhar"
          [pTooltip]="podeCompartilharEdicao() ? tooltips.compartilhar : tooltips.compartilhar_indisponivel"
          tooltipPosition="top"
          (click)="compartilharItemEmEdicao()"></button>
      </div>

      <!-- Grid de Cards do Formulario -->
      <div class="form-cards-container">
        <!-- Coluna Esquerda -->
        <div class="column-left">
          <!-- Card Informacao Geral -->
          <div class="form-card">
            <div class="card-header">
              <div class="card-header-icon">
                <i class="pi pi-info-circle"></i>
              </div>
              <span class="card-header-title">{{ 'produtos.texts.informacao_geral' | translate }}</span>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <div class="form-field half">
                  <label class="form-label">{{ 'produtos.labels.nome' | translate }} <span class="required">*</span></label>
                  <input [class.error-field]="isFormSubmitted && !form.nome" [(ngModel)]="form.nome" type="text" pInputText
                    placeholder="{{ 'produtos.placeholders.digite_o_nome' | translate }}" class="w-full" />
                </div>
                <div class="form-field half">
                  <label class="form-label">{{ 'produtos.labels.codigo_de_barras' | translate }}</label>
                  <input [(ngModel)]="form.barras" type="text" pInputText
                    placeholder="{{ 'produtos.placeholders.digite_o_codigo' | translate }}" class="w-full" />
                </div>
                <div class="form-field third">
                  <label class="form-label">{{ 'produtos.labels.grupo' | translate }} <span class="required">*</span></label>
                  <app-select-grupo id="categoria" [(ngModel)]="form.grupo_id" [returnType]="'id'" (ngModelChange)="onGrupoChange($event)" />
                </div>
                <div class="form-field third">
                  <label class="form-label">{{ 'produtos.labels.sub_grupo' | translate }}</label>
                  <app-select-subgrupo id="subCategoria" [(ngModel)]="form.subGrupo_id" [returnType]="'id'" [grupoId]="form.grupo_id" />
                </div>
                <div class="form-field third">
                  <label class="form-label">{{ 'produtos.labels.marca' | translate }}</label>
                  <app-select-marca id="marca" [(ngModel)]="form.marca_id" [returnType]="'id'" />
                </div>
                <div class="form-field third">
                  <label class="form-label">{{ 'produtos.labels.tipo_de_item' | translate }} <span class="required">*</span></label>
                  <p-dropdown [class.error-field]="isFormSubmitted && !form.tipoItem" [options]="tipoDeItensOptions"
                    optionLabel="label" [(ngModel)]="form.tipoItem"
                    (ngModelChange)="onTipoItemChange()"
                    [placeholder]="form.id ? getTipoItemLabel() : ('produtos.placeholders.selecionar_tipo_produto' | translate)"
                    styleClass="w-full"></p-dropdown>
                </div>
                <div class="form-field third">
                  <label class="form-label">{{ 'produtos.labels.preco_de_venda' | translate }} <span class="required">*</span></label>
                  <div class="currency-input-container">
                    <span class="currency-symbol-inside-input">{{ currencySymbol }}</span>
                    <input type="text" pInputText
                      [placeholder]="'produtos.placeholders.digite_o_preco' | translate"
                      class="currency-input-with-symbol w-full"
                      [value]="precoDeVendaStr"
                      (input)="formatarCampoPreco($event, 'precoDeVenda')"
                      [class.error-field]="isFormSubmitted && form.precoDeVenda == null" />
                  </div>
                </div>
                <div class="form-field third" *ngIf="!ehServico">
                  <label class="form-label">{{ 'produtos.labels.custo' | translate }} <span class="required">*</span></label>
                  <div class="currency-input-container">
                    <span class="currency-symbol-inside-input">{{ currencySymbol }}</span>
                    <input type="text" pInputText
                      [placeholder]="'produtos.placeholders.digite_o_custo' | translate"
                      class="currency-input-with-symbol w-full"
                      [value]="custoStr"
                      (input)="formatarCampoPreco($event, 'custo')"
                      [class.error-field]="isFormSubmitted && form.custo == null" />
                  </div>
                </div>
                <!-- Status (visivel apenas em modo edicao) -->
                <div class="form-field full" *ngIf="form.id">
                  <label class="form-label">{{ 'produtos-edit.labels.status' | translate }}</label>
                  <div class="status-toggle-container">
                    <p-inputSwitch [(ngModel)]="form.status" class="status-switch"></p-inputSwitch>
                    <span class="status-label" [ngClass]="{'status-active': form.status, 'status-inactive': !form.status}">
                      {{ form.status ? ('produtos-edit.texts.ativo' | translate) : ('produtos-edit.texts.inativo' | translate) }}
                    </span>
                  </div>
                </div>
                <!-- Indicado e Genero (exibidos no shop): acima da descricao. -->
                <div class="form-field half">
                  <label class="form-label">{{ 'produtos.labels.indicado' | translate }}</label>
                  <input
                    pInputText
                    type="text"
                    maxlength="255"
                    [(ngModel)]="indicado"
                    [placeholder]="'produtos.placeholders.indicado' | translate"
                    class="w-full" />
                </div>
                <div class="form-field half">
                  <label class="form-label">{{ 'produtos.labels.genero' | translate }}</label>
                  <p-dropdown
                    [(ngModel)]="genero"
                    [options]="generoOpcoes"
                    optionValue="value"
                    [placeholder]="'produtos.placeholders.genero' | translate"
                    [showClear]="true"
                    appendTo="body"
                    styleClass="w-full">
                    <ng-template let-opcao pTemplate="item">
                      {{ opcao.label | translate }}
                    </ng-template>
                    <ng-template let-selecionado pTemplate="selectedItem">
                      {{ selecionado.label | translate }}
                    </ng-template>
                  </p-dropdown>
                </div>

                <div class="form-field full">
                  <label class="form-label">{{ 'produtos.labels.descricao' | translate }}</label>
                  <textarea [(ngModel)]="form.descricao" pInputTextarea [rows]="3" [autoResize]="true"
                    placeholder="{{ 'produtos.placeholders.digite_a_descricao' | translate }}" class="w-full"
                    style="min-height: 70px;"></textarea>
                </div>
                <div class="form-field full">
                  <label class="form-label">{{ 'produtos.labels.imagem' | translate }}</label>
                  <!-- Preview de imagem existente (modo edicao) -->
                  <div class="edit-product-image-container" *ngIf="form.id && form.imagem && imagePreviewUrl">
                    <img class="edit-product-image edit-product-image-clicavel"
                         [src]="imagePreviewUrl"
                         alt="Imagem do produto"
                         (click)="abrirImagemExpandida()"
                         [title]="'produtos-edit.texts.clique_para_expandir' | translate" />
                    <button pButton class="p-button p-button-icon-only" icon="pi pi-trash" (click)="onClearImage()"></button>
                  </div>
                  <p-fileUpload name="grupo" [multiple]="false" accept="image/jpeg,image/png,image/gif" [maxFileSize]="2000000"
                    [showUploadButton]="false" [showCancelButton]="true"
                    chooseLabel="{{'grupo.botoes.selecionar_imagem' | translate}}"
                    cancelLabel="{{'grupo.botoes.remover' | translate}}" (onSelect)="onSelectImage($event)"
                    (onClear)="onClearImage()">
                  </p-fileUpload>
                </div>

                <!-- Imagens secundarias do item (so em modo edicao - precisa do itemId) -->
                <div class="form-field full" *ngIf="form.id">
                  <app-item-imagens-secundarias
                    [itemId]="form.id"
                    [disabled]="form.itemDeSistema === true"></app-item-imagens-secundarias>
                </div>
              </div>
            </div>
          </div>

          <!-- Card Estoque -->
          <div class="form-card">
            <div class="card-header">
              <div class="card-header-icon stock-icon">
                <i class="pi pi-warehouse"></i>
              </div>
              <span class="card-header-title">{{ 'produtos.texts.estoque' | translate }}</span>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <div class="form-field half"
                     *ngIf="!ehServico"
                     [pTooltip]="form.id ? tooltips.saldo_readonly : ''" tooltipPosition="top">
                  <label class="form-label">{{ 'produtos.labels.saldo' | translate }} <span class="required">*</span></label>
                  <app-input-quantidade [class.error-field]="isFormSubmitted && form.saldo == null" [(ngModel)]="form.saldo"
                    [casasDecimais]="casasDecimaisEstoque"
                    [disabled]="!!form.id"
                    [style]="{ width: '100%' }"></app-input-quantidade>
                </div>
                <div class="form-field half" *ngIf="!ehServico">
                  <label class="form-label">{{ 'produtos.labels.estoque_minimo' | translate }} <span class="required">*</span></label>
                  <app-input-quantidade [class.error-field]="isFormSubmitted && form.estoqueMinimo == null" [(ngModel)]="form.estoqueMinimo"
                    [casasDecimais]="casasDecimaisEstoque"
                    [style]="{ width: '100%' }"></app-input-quantidade>
                </div>
                <div class="form-field half">
                  <label class="form-label">{{ 'produtos.labels.unidade_de_medida' | translate }} <span class="required">*</span></label>
                  <p-dropdown [class.error-field]="isFormSubmitted && !form.unidadeMedidaDeItem_id" [options]="unidadesMedida"
                    optionLabel="label" optionValue="value" [(ngModel)]="form.unidadeMedidaDeItem_id"
                    (onChange)="onUnidadeMedidaChange()"
                    placeholder="{{ 'produtos.placeholders.selecionar_unidade_medida' | translate }}" styleClass="w-full"></p-dropdown>
                </div>
                <div class="form-field half" *ngIf="!ehServico">
                  <label class="form-label">{{ 'produtos.labels.fornecedor_principal' | translate }}</label>
                  <p-dropdown [options]="fornecedores" optionLabel="label"
                    [(ngModel)]="form.fornecedorPrincipal_id"
                    [optionValue]="form.id ? 'value' : undefined"
                    placeholder="{{ 'produtos.placeholders.selecionar_fornecedor' | translate }}" styleClass="w-full"></p-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Coluna Direita -->
        <div class="column-right">
          <!-- Card Dados Adicionais -->
          <div class="form-card">
            <div class="card-header">
              <div class="card-header-icon additional-icon">
                <i class="pi pi-cog"></i>
              </div>
              <span class="card-header-title">{{ 'produtos.texts.dados_adicionais' | translate }}</span>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <div class="form-field half">
                  <label class="form-label">{{ 'produtos.labels.tipo_de_imposto' | translate }} <span class="required">*</span></label>
                  <p-dropdown [class.error-field]="isFormSubmitted && !form.tipoDeImposto" [options]="tipoDeImpostoOptions"
                    optionLabel="label" optionValue="value" [(ngModel)]="form.tipoDeImposto"
                    [placeholder]="form.id ? getTipoImpostoLabel() : ('produtos.placeholders.selecionar_tipo_imposto' | translate)"
                    styleClass="w-full"></p-dropdown>
                </div>
                <div class="form-field half">
                  <label class="form-label">
                    {{ 'produtos.labels.habilitar_mini_shop' | translate }}
                    <!-- Ajuda do campo bloqueado: aponta onde ativar o Mini Shop da empresa.
                         E <button> (nao <i>) com tooltipEvent="both": abre tambem no foco, entao
                         funciona por teclado e leitor de tela. Sem link para o destino, que exige a
                         permissao `configuracaoMinishop` - quem edita produto pode nao ter. -->
                    <button *ngIf="!habilitarMiniShoppingEmpresaConfig"
                      type="button"
                      class="campo-ajuda-btn"
                      icon="pi pi-info-circle"
                      pButton
                      [pTooltip]="'produtos.texts.mini_shop_desabilitado_ajuda' | translate"
                      tooltipEvent="both"
                      tooltipPosition="top"
                      [attr.aria-label]="'produtos.texts.mini_shop_desabilitado_aria' | translate">
                    </button>
                  </label>
                  <p-dropdown [options]="habilitarMiniShopping" optionLabel="label" optionValue="value"
                    [disabled]="!habilitarMiniShoppingEmpresaConfig" [(ngModel)]="form.habilitarMiniShopping"
                    (onChange)="onMiniShopChange()"
                    [ngClass]="{'input-field-disabled': !habilitarMiniShoppingEmpresaConfig}" styleClass="w-full">
                  </p-dropdown>
                </div>
                <div class="form-field half" *ngIf="imprimirItensDeAcordoImpressoraEmpresaConfig">
                  <label class="form-label">{{ 'produtos.labels.impressora_predeterminada' | translate }}</label>
                  <app-select-impressora [(ngModel)]="form.impressoraPadraoId"
                    [ngModelOptions]="{standalone: true}"></app-select-impressora>
                </div>
                <div class="form-field half" *ngIf="imprimirItensDeAcordoImpressoraEmpresaConfig">
                  <label class="form-label">{{ 'produtos.labels.imprimir_itens_segundo_impressora' | translate }}</label>
                  <p-dropdown [options]="permiteImprimir" optionLabel="label" optionValue="value"
                    [(ngModel)]="form.permiteImprimir" styleClass="w-full">
                  </p-dropdown>
                </div>
                <!-- Impressao de PEDIDO (comanda de producao). Gate proprio: basta a empresa
                     imprimir pedidos automaticamente por uma das origens (local ou minishop). -->
                <div class="form-field half" *ngIf="imprimirPedidoAutomaticoEmpresaConfig">
                  <label class="form-label">{{ 'produtos.labels.impressora_predeterminada_pedido' | translate }}</label>
                  <app-select-impressora [(ngModel)]="form.impressoraPadraoPedidoId"
                    [ngModelOptions]="{standalone: true}"></app-select-impressora>
                </div>
                <div class="form-field half" *ngIf="imprimirPedidoAutomaticoEmpresaConfig">
                  <label class="form-label">{{ 'produtos.labels.imprimir_itens_segundo_impressora_pedido' | translate }}</label>
                  <p-dropdown [options]="permiteImprimir" optionLabel="label" optionValue="value"
                    [(ngModel)]="form.permiteImprimirPedido" styleClass="w-full">
                  </p-dropdown>
                </div>
              </div>
            </div>
          </div>

          <!-- Card Promocao e Novidade (visivel apenas com MiniShop ativo e nao item de sistema — RN08) -->
          <div class="form-card" *ngIf="form.habilitarMiniShopping === true && !ehItemDeSistema">
            <div class="card-header">
              <div class="card-header-icon additional-icon">
                <i class="pi pi-star"></i>
              </div>
              <span class="card-header-title">{{ 'produtos.texts.promocao_e_novidade' | translate }}</span>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <div class="form-field half">
                  <label class="form-label">{{ 'produtos.labels.promocao' | translate }}</label>
                  <div class="status-toggle-container">
                    <p-inputSwitch
                      inputId="switchPromocaoInline"
                      [(ngModel)]="promocao"
                      (onChange)="onPromocaoChange()"
                      class="status-switch">
                    </p-inputSwitch>
                    <span class="status-label" [ngClass]="{'status-active': promocao, 'status-inactive': !promocao}">
                      {{ promocao ? ('produtos.labels.sim' | translate) : ('produtos.labels.nao' | translate) }}
                    </span>
                  </div>
                </div>
                <div class="form-field half" *ngIf="promocao">
                  <label class="form-label">{{ 'produtos.labels.promocao_ate' | translate }} <span class="required">*</span></label>
                  <p-calendar
                    [(ngModel)]="promocaoAteEmData"
                    [showTime]="true"
                    [showSeconds]="false"
                    hourFormat="24"
                    [minDate]="dataMinimaPromocaoNovidade"
                    appendTo="body"
                    dateFormat="dd/mm/yy"
                    styleClass="w-full">
                  </p-calendar>
                </div>
                <div class="form-field half">
                  <label class="form-label">{{ 'produtos.labels.novidade' | translate }}</label>
                  <div class="status-toggle-container">
                    <p-inputSwitch
                      inputId="switchNovidadeInline"
                      [(ngModel)]="novidade"
                      (onChange)="onNovidadeChange()"
                      class="status-switch">
                    </p-inputSwitch>
                    <span class="status-label" [ngClass]="{'status-active': novidade, 'status-inactive': !novidade}">
                      {{ novidade ? ('produtos.labels.sim' | translate) : ('produtos.labels.nao' | translate) }}
                    </span>
                  </div>
                </div>
                <div class="form-field half" *ngIf="novidade">
                  <label class="form-label">{{ 'produtos.labels.novidade_ate' | translate }} <span class="required">*</span></label>
                  <p-calendar
                    [(ngModel)]="novidadeAteEmData"
                    [showTime]="true"
                    [showSeconds]="false"
                    hourFormat="24"
                    [minDate]="dataMinimaPromocaoNovidade"
                    appendTo="body"
                    dateFormat="dd/mm/yy"
                    styleClass="w-full">
                  </p-calendar>
                </div>
              </div>
            </div>
          </div>

          <!-- Card Variantes de Preco -->
          <div class="form-card variantes-card">
            <div class="card-header">
              <div class="card-header-icon variantes-icon">
                <i class="pi pi-tags"></i>
              </div>
              <span class="card-header-title">{{ 'produtos-edit.texts.variantes_de_preco' | translate }}</span>
            </div>
            <div class="card-content">
              <p class="variantes-descricao">{{ 'produtos-edit.texts.variantes_descricao' | translate }}</p>

              <!-- Lista de variantes -->
              <div *ngFor="let variante of variantes; let i = index; trackBy: trackByVariante" class="variante-item">
                <div class="variante-campos">
                  <div class="form-field variante-descricao-field">
                    <label class="form-label">{{ 'produtos-edit.labels.variante_descricao' | translate }}</label>
                    <input
                      #varianteDescricaoInput
                      [(ngModel)]="variante.descricao"
                      type="text"
                      pInputText
                      placeholder="{{ 'produtos-edit.placeholders.variante_descricao' | translate }}"
                      class="w-full" />
                  </div>
                  <div class="form-field variante-preco-field">
                    <label class="form-label">{{ 'produtos-edit.labels.variante_preco' | translate }}</label>
                    <div class="currency-input-container">
                      <span class="currency-symbol-inside-input">{{ currencySymbol }}</span>
                      <input type="text" pInputText
                        placeholder="0"
                        class="currency-input-with-symbol w-full"
                        [value]="formatarValorParaExibicao(variante.precoDeVenda)"
                        (input)="formatarCampoPrecoVariante($event, variante)" />
                    </div>
                  </div>
                </div>
                <div class="variante-acoes">
                  <button pButton
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-text p-button-danger"
                    (click)="removerVariante(i)"
                    [pTooltip]="'produtos-edit.tooltips.remover_variante' | translate">
                  </button>
                </div>
              </div>

              <!-- Estado vazio -->
              <div *ngIf="variantes.length === 0" class="variantes-empty">
                <i class="pi pi-tags variantes-empty-icon"></i>
                <p>{{ 'produtos-edit.texts.sem_variantes' | translate }}</p>
              </div>

              <!-- Botao adicionar variante -->
              <div class="variantes-actions-row">
                <button pButton
                  icon="pi pi-plus"
                  class="p-button-outlined p-button-sm flex-1 btn-adicionar-variante"
                  (click)="adicionarVariante()">
                  {{ 'produtos-edit.botoes.adicionar_variante' | translate }}
                </button>
                <button pButton
                  *ngIf="form.id"
                  icon="pi pi-check"
                  class="p-button-sm p-button-success btn-salvar-secao"
                  [loading]="salvandoVariantes"
                  [disabled]="variantes.length === 0"
                  (click)="salvarVariantes()">
                  {{ 'produtos-edit.botoes.salvar_variantes' | translate }}
                </button>
              </div>
            </div>
          </div>

          <!-- Card Grupos de Modificadores -->
          <div class="form-card modificadores-card">
            <div class="card-header">
              <div class="card-header-icon modificadores-icon">
                <i class="pi pi-sliders-h"></i>
              </div>
              <span class="card-header-title">{{ 'produtos-edit.texts.modificadores' | translate }}</span>
            </div>
            <div class="card-content">
              <p class="variantes-descricao">{{ 'produtos-edit.texts.modificadores_descricao' | translate }}</p>

              <!-- Lista de grupos de modificadores -->
              <div *ngFor="let grupo of gruposModificadores; let gi = index; trackBy: trackByGrupo" class="grupo-modificador">

                <!-- Cabecalho do grupo -->
                <div class="grupo-header">
                  <div class="grupo-campos-vertical">
                    <div class="grupo-nome-row">
                      <div class="form-field flex-1">
                        <label class="form-label">{{ 'produtos-edit.labels.grupo_modificador_pergunta' | translate }}</label>
                        <input
                          #grupoDescricaoInput
                          [(ngModel)]="grupo.descricao"
                          type="text"
                          pInputText
                          placeholder="{{ 'produtos-edit.placeholders.grupo_modificador_pergunta' | translate }}"
                          class="w-full" />
                      </div>
                      <div class="grupo-acoes">
                        <button pButton
                          icon="pi pi-trash"
                          class="p-button-rounded p-button-text p-button-danger"
                          (click)="removerGrupoModificador(gi)"
                          [pTooltip]="'produtos-edit.tooltips.remover_grupo' | translate">
                        </button>
                      </div>
                    </div>
                    <div class="grupo-config-row">
                      <div class="grupo-toggle-item">
                        <label class="form-label">{{ 'produtos-edit.labels.cliente_deve_escolher' | translate }}</label>
                        <p-inputSwitch
                          [ngModel]="grupo.minimoDeModificadores > 0"
                          (ngModelChange)="onToggleObrigatorio(gi, $event)">
                        </p-inputSwitch>
                      </div>
                      <div class="grupo-toggle-item">
                        <label class="form-label">{{ 'produtos-edit.labels.pode_escolher_mais_de_um' | translate }}</label>
                        <p-inputSwitch
                          [ngModel]="grupo.maximoDeModificadores > 1"
                          (ngModelChange)="onToggleMultiplo(gi, $event)">
                        </p-inputSwitch>
                      </div>
                      <div class="grupo-toggle-item" *ngIf="grupo.maximoDeModificadores > 1">
                        <label class="form-label">{{ 'produtos-edit.labels.ate_quantos' | translate }}</label>
                        <p-inputNumber
                          [(ngModel)]="grupo.maximoDeModificadores"
                          [min]="2"
                          [max]="20"
                          styleClass="grupo-ate-quantos-input">
                        </p-inputNumber>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Opcoes do grupo -->
                <div class="opcoes-container">
                  <label class="opcoes-section-label">{{ 'produtos-edit.labels.opcoes_disponiveis' | translate }}</label>
                  <div *ngFor="let mod of grupo.modificadores; let mi = index; trackBy: trackByModificador" class="opcao-item">
                    <div class="form-field flex-1">
                      <label class="form-label" *ngIf="mi === 0">{{ 'produtos-edit.labels.opcao_nome' | translate }}</label>
                      <input
                        #modificadorDescricaoInput
                        [(ngModel)]="mod.descricao"
                        type="text"
                        pInputText
                        placeholder="{{ 'produtos-edit.placeholders.opcao_nome' | translate }}"
                        class="w-full" />
                    </div>
                    <div class="form-field opcao-preco-field">
                      <label class="form-label" *ngIf="mi === 0">{{ 'produtos-edit.labels.preco_adicional' | translate }}</label>
                      <div class="currency-input-container">
                        <span class="currency-symbol-inside-input">{{ currencySymbol }}</span>
                        <input type="text" pInputText
                          placeholder="0"
                          class="currency-input-with-symbol w-full"
                          [value]="formatarValorParaExibicao(mod.precoDeVenda)"
                          (input)="formatarCampoPrecoModificador($event, mod)" />
                      </div>
                    </div>
                    <button pButton
                      icon="pi pi-trash"
                      class="p-button-rounded p-button-text p-button-danger p-button-sm"
                      [ngClass]="{'opcao-btn-primeira-linha': mi === 0}"
                      (click)="removerModificador(gi, mi)"
                      [pTooltip]="'produtos-edit.tooltips.remover_opcao' | translate">
                    </button>
                  </div>

                  <!-- Botao adicionar opcao -->
                  <button pButton
                    icon="pi pi-plus"
                    class="p-button-text p-button-sm btn-adicionar-opcao"
                    (click)="adicionarModificador(gi)">
                    {{ 'produtos-edit.botoes.adicionar_opcao' | translate }}
                  </button>
                </div>
              </div>

              <!-- Estado vazio -->
              <div *ngIf="gruposModificadores.length === 0" class="variantes-empty">
                <i class="pi pi-sliders-h variantes-empty-icon"></i>
                <p>{{ 'produtos-edit.texts.sem_modificadores' | translate }}</p>
              </div>

              <!-- Botao adicionar grupo -->
              <div class="variantes-actions-row">
                <button pButton
                  icon="pi pi-plus"
                  class="p-button-outlined p-button-sm flex-1 btn-adicionar-variante"
                  (click)="adicionarGrupoModificador()">
                  {{ 'produtos-edit.botoes.adicionar_grupo_modificador' | translate }}
                </button>
                <button pButton
                  *ngIf="form.id"
                  icon="pi pi-check"
                  class="p-button-sm p-button-success btn-salvar-secao"
                  [loading]="salvandoModificadores"
                  [disabled]="gruposModificadores.length === 0"
                  (click)="salvarModificadores()">
                  {{ 'produtos-edit.botoes.salvar_modificadores' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botoes de Acao do Formulario -->
      <div class="form-actions-container">
        <button pButton *ngIf="form.id"
          (click)="limparFormulario()"
          severity="secondary" icon="pi pi-eraser" class="btn-secondary">
          {{ botoes.limpar }}
        </button>
        <button pButton icon="pi pi-check"
          (click)="submitForm()" class="btn-primary">
          {{ form.id ? botoes.atualizar : botoes.salvar }} (Ctrl+Enter)
        </button>
      </div>
    </p-tabPanel>

    <!-- Aba 2: Lista -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ texts.aba_lista }}</span>
      </ng-template>

      <!-- Card: Lista de Produtos -->
      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-list"></i>
          </div>
          <span class="card-header-title">{{ texts.lista_de_produtos }}</span>
          <div class="card-header-actions">
            <button pButton [label]="botoes.novo_produto" icon="pi pi-plus"
              (click)="novoProduto()" class="btn-primary btn-sm"></button>
          </div>
        </div>
        <div class="card-content">
          <!-- Indicador de filtro por fornecedor -->
          <div *ngIf="fornecedorId" class="fornecedor-filter-bar">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-filter" style="color: var(--primary-color);"></i>
              <span class="font-semibold">{{ texts.filtrado_por_fornecedor }}:</span>
              <span class="fornecedor-chip">
                <i class="pi pi-truck mr-1"></i>
                {{ fornecedorNome || '#' + fornecedorId }}
              </span>
              <button pButton class="p-button-text p-button-rounded p-button-sm p-button-danger"
                icon="pi pi-times"
                [pTooltip]="texts.limpar_filtro" tooltipPosition="top"
                (click)="limparFiltroFornecedor()"></button>
            </div>
          </div>

          <!-- Barra de busca + Seletor de colunas -->
          <div class="search-bar">
            <p-iconField iconPosition="right" class="search-field">
              <p-inputIcon styleClass="pi pi-search" />
              <input #searchInput pInputText type="text"
                [placeholder]="placeholders.pesquisar"
                [(ngModel)]="searchNome"
                (ngModelChange)="onSearchChange($event)"
                (keyup.enter)="search()" />
            </p-iconField>

            <app-column-selector
              [columns]="columns"
              [storageKey]="STORAGE_KEY"
              (columnsChange)="onColumnsChange($event)">
            </app-column-selector>
          </div>

          <!-- Tabela -->
          <p-table [value]="produtos" [loading]="loading"
            (sortFunction)="customSort($event)" [customSort]="true"
            [tableStyle]="{ 'width': '100%' }">

            <ng-template pTemplate="header">
              <tr>
                <th [hidden]="!isColumnVisible('imagem')" style="width: 7%">
                  {{ labels.imagem }}
                </th>
                <th [hidden]="!isColumnVisible('codigoItem')" pSortableColumn="codigoItem" style="width: 8%">
                  {{ labels.codigo_item }}<p-sortIcon [field]="'codigoItem'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('barras')" pSortableColumn="barras" style="width: 10%">
                  {{ labels.codigo_de_barras }}<p-sortIcon [field]="'barras'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('nome')" pSortableColumn="nome" style="width: 15%">
                  {{ labels.nome }}<p-sortIcon [field]="'nome'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('grupo')" pSortableColumn="grupo" style="width: 9%">
                  {{ labels.grupo }}<p-sortIcon [field]="'grupo'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('subGrupo')" pSortableColumn="subGrupo" style="width: 10%">
                  {{ labels.sub_grupo }}<p-sortIcon [field]="'subGrupo'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('marca')" pSortableColumn="marca" style="width: 10%">
                  {{ labels.marca }}<p-sortIcon [field]="'marca'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('saldo')" pSortableColumn="saldo" style="width: 8%">
                  {{ labels.saldo }}<p-sortIcon [field]="'saldo'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('custo')" pSortableColumn="custo" style="width: 10%">
                  {{ labels.preco_de_custo }}<p-sortIcon [field]="'custo'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('precoDeVenda')" pSortableColumn="precoDeVenda" style="width: 10%">
                  {{ labels.preco_de_venda }}<p-sortIcon [field]="'precoDeVenda'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('acoes')" style="width: 10%">{{ labels.acoes }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-produto>
              <tr>
                <td [hidden]="!isColumnVisible('imagem')">
                  <div class="product-image-container clickable"
                    tabindex="0"
                    role="button"
                    [attr.aria-label]="produto.nome"
                    (click)="abrirImagensDoProduto(produto); $event.stopPropagation()"
                    (keydown.enter)="abrirImagensDoProduto(produto)">
                    <img
                      class="product-image"
                      [src]="getImagemUrl(produto.imagem || '')"
                      [alt]="produto.nome"
                      loading="lazy"
                      (error)="onImageError($event, produto.id!)" />
                  </div>
                </td>
                <td [hidden]="!isColumnVisible('codigoItem')">{{ produto.codigoItem }}</td>
                <td [hidden]="!isColumnVisible('barras')">{{ produto.barras || '-' }}</td>
                <td [hidden]="!isColumnVisible('nome')">
                  <span class="prod-nome-cell">
                    <span>{{ produto.nome }}</span>
                    <i *ngIf="produto.promocao" class="fas fa-tag prod-tag-icone prod-tag-icone--promo"
                      [pTooltip]="'produtos.tags.promocao' | translate" tooltipPosition="top"
                      [attr.aria-label]="'produtos.tags.promocao' | translate"></i>
                    <i *ngIf="produto.novidade" class="pi pi-star-fill prod-tag-icone prod-tag-icone--novidade"
                      [pTooltip]="'produtos.tags.novidade' | translate" tooltipPosition="top"
                      [attr.aria-label]="'produtos.tags.novidade' | translate"></i>
                  </span>
                </td>
                <td [hidden]="!isColumnVisible('grupo')">{{ produto.grupo?.nome || '-' }}</td>
                <td [hidden]="!isColumnVisible('subGrupo')">{{ produto.subGrupo?.nome || '-' }}</td>
                <td [hidden]="!isColumnVisible('marca')">{{ produto.marca?.nome || '-' }}</td>
                <td [hidden]="!isColumnVisible('saldo')" class="saldo-column">
                  <div class="saldo-content">
                    {{ formatarSaldoProduto(produto) }}
                    <!-- Ajuste rapido de saldo: fora de escopo no modo embutido (usa /ajusteDeEstoque). -->
                    <button *ngIf="!embutido" pButton icon="pi pi-pencil"
                      class="p-button-rounded p-button-text p-button-sm"
                      [pTooltip]="tooltips.atualizar_saldo" tooltipPosition="top"
                      (click)="showDialogSaldo(produto)"></button>
                  </div>
                </td>
                <td [hidden]="!isColumnVisible('custo')">
                  <ng-container *ngIf="moedaPadrao === 'PYG'">{{ produto.custo | guaraniFormat }}</ng-container>
                  <ng-container *ngIf="moedaPadrao !== 'PYG'">{{ produto.custo | currency: moedaPadrao:'symbol':digitsMoeda:localeMoeda }}</ng-container>
                </td>
                <td [hidden]="!isColumnVisible('precoDeVenda')">
                  <ng-container *ngIf="moedaPadrao === 'PYG'">{{ produto.precoDeVenda | guaraniFormat }}</ng-container>
                  <ng-container *ngIf="moedaPadrao !== 'PYG'">{{ produto.precoDeVenda | currency: moedaPadrao:'symbol':digitsMoeda:localeMoeda }}</ng-container>
                </td>
                <td [hidden]="!isColumnVisible('acoes')" class="actions">
                  <button pButton icon="pi pi-pencil"
                    class="p-button-text p-button-rounded p-button-sm action-btn-desktop"
                    [pTooltip]="tooltips.editar" tooltipPosition="top"
                    (click)="editarProduto(produto.id)"></button>
                  <!-- Excluir: oculto para itens de sistema (nao-excluiveis) e no modo embutido -->
                  <button pButton icon="pi pi-trash"
                    *ngIf="!produto.itemDeSistema && !embutido"
                    class="p-button-text p-button-rounded p-button-sm p-button-danger action-btn-desktop"
                    [pTooltip]="tooltips.excluir" tooltipPosition="top"
                    (click)="deletar(produto.id)"></button>
                  <!-- Indicador visual para item de sistema -->
                  <i *ngIf="produto.itemDeSistema"
                    class="pi pi-shield text-500 action-btn-desktop"
                    style="padding: 0.5rem;"
                    [pTooltip]="tooltips.item_de_sistema_hint"
                    tooltipPosition="top"></i>
                  <button pButton icon="pi pi-ellipsis-v"
                    class="p-button-text p-button-rounded p-button-sm"
                    [pTooltip]="tooltips.mais_acoes" tooltipPosition="top"
                    (click)="toggleMenu($event, produto)"></button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex flex-column align-items-center">
                    <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                    <div class="text-gray-500 text-lg">{{ texts.nenhum_produto }}</div>
                    <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex justify-content-center align-items-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <span class="ml-3">{{ texts.carregando }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Paginacao -->
          <div class="pagination-container">
            <div>
              <p-paginator (onPageChange)="onPageChange($any($event))"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                [first]="first" [rows]="rows"
                [totalRecords]="totalRecords" [showFirstLastIcon]="true">
              </p-paginator>
            </div>
            <div class="flex align-items-center">
              <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
              <p-dropdown [options]="pageSizeOptions" optionLabel="label"
                optionValue="value" [(ngModel)]="rows"
                (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>

  </p-tabView>
</div>

<!-- Dialog de Imagem Expandida (tabela) -->
<p-dialog [(visible)]="displayDialogImage" [modal]="true" [closeOnEscape]="true"
  styleClass="expanded-product-dialog"
  [style]="{ width: '90vw', maxWidth: '600px', padding: '0' }">
  <div class="expanded-image-container">
    <img [src]="expandedImageUrl" class="expanded-product-image"
      (error)="onExpandedImageError($event)" />
  </div>
</p-dialog>

<!-- Dialog de Atualizar Saldo -->
<p-dialog *ngIf="produtoSelecionado"
  [(visible)]="displayDialogSaldo"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '25rem' }">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-box" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.atualizar_quantidade_do_produto }}</h2>
        <p>{{ labels.saldo }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-saldo-content">
    <div class="flex align-items-center gap-3 mb-3">
      <label for="saldo" class="font-semibold w-6rem">{{ labels.saldo }}</label>
      <p-inputNumber id="saldo" [(ngModel)]="produtoSelecionado.saldo"
        [minFractionDigits]="casasDecimaisEstoqueSaldo" [maxFractionDigits]="casasDecimaisEstoqueSaldo" [useGrouping]="false"
        styleClass="flex-auto" inputStyleClass="w-full"></p-inputNumber>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary"
      (click)="closeDialogSaldo()"></button>
    <button pButton [label]="botoes.salvar"
      (click)="salvarAjusteSaldo()"></button>
  </ng-template>
</p-dialog>

<!-- Dialog de Confirmacao de Exclusao (Wave Pattern) -->
<p-dialog
  [(visible)]="deleteDialogVisible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts.confirmar_exclusao }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary"
      (click)="deleteDialogVisible = false"></button>
    <button pButton [label]="botoes.confirmar" severity="danger" icon="pi pi-trash"
      (click)="confirmarExclusao()"></button>
  </ng-template>
</p-dialog>

<!-- Dialog de confirmacao de remocao de grupo de modificador -->
<p-dialog
  [(visible)]="mostrarDialogRemoverGrupo"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '400px', height: 'auto' }">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'produtos-edit.dialogs.remover_grupo_header' | translate }}</h2>
        <p>{{ 'produtos-edit.dialogs.remover_grupo_desc' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ mensagemRemoverGrupo }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" (click)="cancelarRemocaoGrupo()">
      {{ 'common.nao' | translate }} (Esc)
    </button>
    <button pButton severity="danger" icon="pi pi-trash" (click)="confirmarRemocaoGrupoFinal()">
      {{ 'common.sim' | translate }} (Enter)
    </button>
  </ng-template>
</p-dialog>

<!-- Dialog de Etiqueta -->
<app-etiqueta-item
  [(visible)]="displayDialogEtiqueta"
  [produto]="produtoEtiqueta">
</app-etiqueta-item>

<!-- Lightbox - Imagem expandida (formulario de edicao) -->
<div class="image-lightbox-overlay"
     *ngIf="imagemExpandida"
     (click)="fecharImagemExpandida()"
     [@fadeAnimation]>
  <button class="lightbox-close-btn" (click)="fecharImagemExpandida()">
    <i class="pi pi-times"></i>
  </button>
  <img class="lightbox-image"
       [src]="imagePreviewUrl"
       alt="Imagem do produto expandida"
       (click)="$event.stopPropagation()" />
</div>

<p-menu #menuAcoes [popup]="true" [model]="menuItems" appendTo="body"></p-menu>

<!-- Dialog de Visualizacao de Imagens Secundarias (Tab Lista) -->
<p-dialog
  *ngIf="produtoSelecionadoParaImagens"
  [(visible)]="imagensDialogVisible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  [style]="{ width: '480px', maxWidth: '95vw', maxHeight: '90vh' }"
  [contentStyle]="{ overflow: 'auto' }"
  styleClass="lp-imagens-dialog dialog-wave-redesign"
  (onHide)="fecharImagensDoProduto()">

  <!-- HEADER WAVE (mesmo padrao dos demais dialogs) -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-images" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ produtoSelecionadoParaImagens.nome }}</h2>
        <p>{{ 'produtos.labels.codigo_item' | translate }}: {{ produtoSelecionadoParaImagens.codigoItem }}</p>
      </div>
    </div>
    <button type="button" class="wave-close-btn"
      (click)="fecharImagensDoProduto()"
      [attr.aria-label]="'common.impressao.fechar' | translate">
      <i class="pi pi-times"></i>
    </button>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <app-item-imagens-carrossel
      [itemId]="produtoSelecionadoParaImagens.id"
      [imagemPrincipalUrl]="produtoSelecionadoParaImagens.imagem || undefined"
      [idEmpresa]="idEmpresa"
      [alt]="produtoSelecionadoParaImagens.nome">
    </app-item-imagens-carrossel>
  </div>
</p-dialog>

<p-toast></p-toast>
